<template>
  <div class="swiperPage pa">
    <!-- 奖励轮播 -->
    <div class="swiper">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in imgList" :key="index" class="swiper-slide">
          <img :src="item.src" alt="" style="height: 100%" />
          <div>{{ item.src }}</div>
        </div>
      </div>
    </div>
    <!-- 如果需要导航按钮 -->
    <!-- <div class="icon icon-next"></div>
    <div class="icon icon-prev"></div> -->
    <!-- 如果需要分页器 -->
    <!-- <div class="swiper-pagination"></div> -->
  </div>
</template>

<script>
import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swipe
export default {
  name: "swiperPage",
  data() {
    return {
      imgList: [
        {
          src: require("../assets/images/page1/PS5.png"),
        },
        {
          src: require("../assets/images/page1/pet.png"),
        },
        {
          src: require("../assets/images/page1/clothing.png"),
        },
        {
          src: require("../assets/images/page1/gold.png"),
        },
      ],
    };
  },
  mounted() {
    this.createdSwiper();
  },
  methods: {
    createdSwiper() {
      new Swiper(".swiperPage .swiper", {
        autoplay: {
          disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换
          delay: 2000,
        },
        //前进后退按钮
        // navigation: {
        //   nextEl: ".swiper-button-prev",
        //   prevEl: ".swiper-button-prev",
        // },
        loop: true, //循环模式选项
        // effect: "fade",
        // observer: true,
        // observeParents: true,
        // pagination: {
        //   el: ".swiper-pagination",//换页器与哪个标签关联
        //   clickable:true//分页器是否可以点击
        // },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.swiperPage {
  width: 2rem;
  height: 2rem;
  bottom: 0;
  left: 0;
  z-index: 94;
  text-align: center;
  font-size: 0.3rem;
  .swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .swiper-slide {
      img {
        width: 100%;
      }
    }
  }
}
</style>